var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h12v2H4zm0-4h12v2H4zm0-4h12v2H4zM0 8h2v2H0zm0-4h2v2H0zm0-4h2v2H0z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMCI+CiAgPHBhdGggZD0iTTQgOGgxMnYySDR6bTAtNGgxMnYySDR6bTAtNGgxMnYySDR6TTAgOGgydjJIMHptMC00aDJ2Mkgwem0wLTRoMnYySDB6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";
export { SvgDefaultSort as ReactComponent };